import { gql } from '@apollo/client';

export const ASSIGNMENTS_LIST = gql`
  query AssignmentsList {
    employeeVehicleAssignmentsList {
      items {
        id
        assignedDate
        unassignedDate
        role
        employee { id name }
        vehicle { id unitNumber }
      }
    }
  }
`;

export const ASSIGNMENT_GET = gql`
  query AssignmentGet($id: ID!) {
    employeeVehicleAssignment(id: $id) {
      id
      assignedDate
      unassignedDate
      role
      employee { id name }
      vehicle { id unitNumber }
    }
  }
`;

export const ASSIGNMENT_CREATE = gql`
  mutation AssignmentCreate($data: EmployeeVehicleAssignmentCreateInput!) {
    employeeVehicleAssignmentCreate(data: $data) {
      id
    }
  }
`;

export const ASSIGNMENT_UPDATE = gql`
  mutation AssignmentUpdate($id: ID!, $data: EmployeeVehicleAssignmentUpdateInput!) {
    employeeVehicleAssignmentUpdate(id: $id, data: $data) {
      id
    }
  }
`;

export const ASSIGNMENT_DELETE = gql`
  mutation AssignmentDelete($id: ID!) {
    employeeVehicleAssignmentDelete(id: $id) {
      success
    }
  }
`; 